import React from "react";

import {Button} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";

import {useOfferPageAmplitudeItemListTrackingContext} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useFavourites} from "../hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {trackAmplitudeAddToFavourites} from "../tracking/track_amplitude_add_to_favourites";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites} = useFavourites();
    const {pageLocation} = useOfferPageAmplitudeItemListTrackingContext();

    const isInFavourites = isPropertyInFavourites(propertyId);

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            const wasAdded = await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            if (!wasAdded) {
                return;
            }

            trackAmplitudeAddToFavourites({itemId: offerId, propertyId, location: pageLocation});
            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Button
            variant={isInFavourites ? "filled_secondary" : theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
            size="small"
            iconLeft={HeartIcon}
            onClick={onFavouriteToggle}
            className={className}
        >
            {isInFavourites ? "W ulubionych" : "Dodaj do ulubionych"}
        </Button>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";

import {useOfferPageAmplitudeItemListTrackingContext} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useFavourites} from "../hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {trackAmplitudeAddToFavourites} from "../tracking/track_amplitude_add_to_favourites";

interface IProps {
    className?: string;
    offerId: number;
    propertyId: number;
    theme: "dark" | "light";
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const AddToFavouritesButton = (props: IProps) => {
    const {offerId, propertyId, theme, className, amplitudePlacement} = props;

    const {isPropertyInFavourites, addPropertyToFavourites, removePropertyFromFavourites} = useFavourites();
    const {pageLocation} = useOfferPageAmplitudeItemListTrackingContext();

    const isInFavourites = isPropertyInFavourites(propertyId);

    const onFavouriteToggle = async () => {
        if (isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else {
            const wasAdded = await addPropertyToFavourites(propertyId, offerId, undefined, amplitudePlacement);

            if (!wasAdded) {
                return;
            }

            trackAmplitudeAddToFavourites({itemId: offerId, propertyId, location: pageLocation});
            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        }
    };

    return (
        <Button
            variant={isInFavourites ? "filled_secondary" : theme === "dark" ? "outlined_secondary_light" : "outlined_secondary"}
            size="small"
            iconLeft={HeartIcon}
            onClick={onFavouriteToggle}
            className={className}
        >
            {isInFavourites ? "W ulubionych" : "Dodaj do ulubionych"}
        </Button>
    );
};
